// Shared class name helpers for BOKF components
// Usage: import { getClassValue, getCombinedStyles } from './bokfDefaultClassNameProvider';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getClassValue = (param: unknown): string => {
  if (!param) return '';
  if (typeof param === 'string') return param;

  const paramObj = param as Record<string, unknown>;
  if (paramObj.Class && typeof paramObj.Class === 'object' && 'value' in paramObj.Class) {
    return typeof paramObj.Class.value === 'string' ? paramObj.Class.value : '';
  }
  if ('value' in paramObj) {
    return typeof paramObj.value === 'string' ? paramObj.value : '';
  }

  return '';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCombinedStyles = (...styleParams: unknown[]): string => {
  try {
    return styleParams
      .map(getClassValue)
      .filter(Boolean)
      .join(' ')
      .replace(/\[object Object\]/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  } catch (error) {
    console.error('Error generating combined styles:', error);
    return '';
  }
};
